// extracted by mini-css-extract-plugin
module.exports = {"container":"BixPj","thumbnail":"_30W76","overlay":"_2ELuO","button":"_2n2VP","arrow":"RiJbd","icon":"_2p0u6"};